const isTestEnv =
  typeof process !== "undefined" && process.env.NODE_ENV === "test";

const TEST_CLEANUP_KEY = "__topcoMainTestCleanup";

if (
  isTestEnv &&
  typeof window !== "undefined" &&
  typeof window[TEST_CLEANUP_KEY] === "function"
) {
  window[TEST_CLEANUP_KEY]();
}

const observerCleanups = [];
const registerObserver = (observer) => {
  observerCleanups.push(observer);
  return observer;
};

if (isTestEnv && typeof window !== "undefined") {
  window[TEST_CLEANUP_KEY] = () => {
    observerCleanups.forEach((observer) => {
      try {
        observer.disconnect();
      } catch (error) {
        // Ignore observer cleanup errors in tests
      }
    });
  };
}
export function initThumbnailSlider() {
  // Sirv mobile thumbnail arrow navigation
  const initSirvThumbs = (strip, stripIndex) => {
    // console.log(`[Sirv Thumbs #${stripIndex}] Initializing strip...`);

    const scroll = strip.querySelector(".smv-scroll");
    const prevBtn = strip.querySelector(".smv-arrow-control-prev .smv-button");
    const nextBtn = strip.querySelector(".smv-arrow-control-next .smv-button");

    if (!scroll || !prevBtn || !nextBtn) {
      console.warn(
        `[Sirv Thumbs #${stripIndex}] inner elements not ready yet, watching strip...`,
      );

      // Watch the strip itself for the next render pass
      const innerObserver = registerObserver(
        new MutationObserver(() => {
          try {
            if (!strip.isConnected) {
              innerObserver.disconnect();
              return;
            }

            const innerScroll = strip.querySelector(".smv-scroll");
            const innerPrev = strip.querySelector(
              ".smv-arrow-control-prev .smv-button",
            );
            const innerNext = strip.querySelector(
              ".smv-arrow-control-next .smv-button",
            );

            if (!innerScroll || !innerPrev || !innerNext) return;

            innerObserver.disconnect();
            initSirvThumbs(strip, stripIndex);
          } catch (error) {
            console.warn(
              `[Sirv Thumbs #${stripIndex}] inner observer error:`,
              error,
            );
          }
        }),
      );

      innerObserver.observe(strip, { childList: true, subtree: true });
      return;
    }

    const VISIBLE_COUNT = 3;
    let currentIndex = 0;

    const getItemWidth = () => {
      const item = scroll.querySelector(".smv-item");
      return item ? item.offsetWidth : 72;
    };

    const getMaxIndex = () =>
      Math.max(0, scroll.querySelectorAll(".smv-item").length - VISIBLE_COUNT);

    const updateArrows = () => {
      const max = getMaxIndex();
      // Only hide both arrows if there's nothing to scroll at all
      const noScroll = max === 0;
      prevBtn
        .closest(".smv-arrow-control")
        .classList.toggle("smv-hidden", currentIndex <= 0);
      nextBtn
        .closest(".smv-arrow-control")
        .classList.toggle("smv-hidden", noScroll);
    };

    const scrollTo = (index) => {
      const itemWidth = getItemWidth();
      currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
      scroll.style.transform = `translate3d(${-(currentIndex * itemWidth)}px, 0px, 0px)`;
      updateArrows();
    };

    prevBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      scrollTo(currentIndex - 1);
    });

    nextBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      if (currentIndex >= getMaxIndex()) {
        scrollTo(0); // wrap to beginning
      } else {
        scrollTo(currentIndex + 1);
      }
    });

    const activeObserver = registerObserver(
      new MutationObserver(() => {
        try {
          if (!scroll.isConnected) {
            activeObserver.disconnect();
            return;
          }

          const items = [...scroll.querySelectorAll(".smv-item")];
          const activeIndex = items.findIndex((el) =>
            el.classList.contains("smv-active"),
          );
          if (activeIndex < 0) return;

          if (activeIndex < currentIndex) scrollTo(activeIndex);
          else if (activeIndex >= currentIndex + VISIBLE_COUNT)
            scrollTo(activeIndex - VISIBLE_COUNT + 1);
          else updateArrows();
        } catch (error) {
          console.warn(
            `[Sirv Thumbs #${stripIndex}] active observer error:`,
            error,
          );
        }
      }),
    );

    activeObserver.observe(scroll, {
      attributes: true,
      subtree: true,
      attributeFilter: ["class"],
    });

    updateArrows();
    // console.log(`[Sirv Thumbs #${stripIndex}] init complete`);
  };

  // Sirv renders async — watch document.body until .smv-thumbnails.smv-h appears
  const sirvObserver = registerObserver(
    new MutationObserver(() => {
      try {
        if (!document.body || !document.body.isConnected) {
          sirvObserver.disconnect();
          return;
        }

        const strips = document.querySelectorAll(
          ".sirv-mobile-wrap .smv-thumbnails.smv-h",
        );
        if (!strips.length) return;

        sirvObserver.disconnect();
        strips.forEach(initSirvThumbs);
      } catch (error) {
        console.warn("[Sirv Thumbs] outer observer error:", error);
      }
    }),
  );

  const initialSirvStrips = document.querySelectorAll(
    ".sirv-mobile-wrap .smv-thumbnails.smv-h",
  );

  if (initialSirvStrips.length) {
    initialSirvStrips.forEach(initSirvThumbs);
    return;
  }

  sirvObserver.observe(document.body, { childList: true, subtree: true });
}

if (typeof process === "undefined" || process.env.NODE_ENV !== "test") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initThumbnailSlider);
  } else {
    initThumbnailSlider();
  }
}

export default { initThumbnailSlider };
